import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const LIVRE_URL = `${backendUrl}/api/livre/`;

class LivreService {
	async getAllLivres() {
		try {
			const response = await axios.get(LIVRE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getLivre(id) {
		return axios.get(`${LIVRE_URL}${id}/`);
	}

	createLivre(data) {
		return axios.post(LIVRE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateLivre(id, data) {
		return axios.put(`${LIVRE_URL}${id}/`, data);
	}

	deletelivre(id) {
		return axios.delete(`${LIVRE_URL}${id}/`);
	}

	getLivreOptions() {
		return this.getAllLivres().then((livres) => {
			const options = livres.map((livre) => ({
				value: livre.id,
				label: (livre.titre + ' ').toUpperCase()
			}));
			return options;
		});
	}
}

export default new LivreService();
